// Private backend responses must never live in the offline worker's caches.
// The previous worker stored them under this name; it is removed on logout/identity
// change and by the next worker's activation (public/push-sw-handlers.js mirrors the name).
export const LEGACY_PRIVATE_CACHE_NAMES = ["supabase-cache"] as const;

type CacheStorageLike = { keys(): Promise<string[]>; delete(name: string): Promise<boolean> };

/** Deletes only the legacy private caches. No-op when the Cache API is absent. Never throws. */
export async function deleteLegacyPrivateCaches(
  storage: CacheStorageLike | undefined = (globalThis as { caches?: CacheStorageLike }).caches,
): Promise<string[]> {
  if (!storage || typeof storage.keys !== "function" || typeof storage.delete !== "function") return [];
  try {
    const names = await storage.keys();
    const targets = names.filter((n) => (LEGACY_PRIVATE_CACHE_NAMES as readonly string[]).includes(n));
    await Promise.allSettled(targets.map((n) => storage.delete(n)));
    return targets;
  } catch {
    return [];
  }
}
